import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const ExpenseDrilldownReport = () => <ReportDrilldownPage type="expense" />;

export default ExpenseDrilldownReport;
